<template>
  <b-modal v-model="modal" title="Disparar WhatsApp de teste" size="md" :no-enforce-focus="true" :no-close-on-backdrop="true">
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>

    <div v-if="template">
      <p class="text-muted mb-3" style="font-size:13px">
        Envia uma mensagem real deste template para o número informado. As variáveis do corpo
        são preenchidas automaticamente com dados do evento e valores de exemplo.
      </p>

      <!-- Preview do template -->
      <TemplatePreview
        :headerType="headerType"
        :headerText="headerText"
        :headerImageUrl="headerImageUrl"
        :headerVideoUrl="headerVideoUrl"
        :headerDocumentName="headerDocumentName"
        :bodyText="bodyText"
        :footerText="footerText"
        :buttons="buttons"
        :examples="{}"
      />

      <form @submit.prevent="send()" autocomplete="off" class="mt-3">
        <div class="form-group">
          <label for="test-phone">Telefone (com DDD)</label>
          <input
            id="test-phone"
            v-model="phone"
            name="phone"
            type="text"
            class="form-control"
            placeholder="(11) 99999-9999"
            :class="{ 'is-invalid': submitted && $v.phone.$error }"
          />
          <div v-if="submitted && !$v.phone.required" class="invalid-feedback">
            Informe o número de telefone.
          </div>
          <small class="text-muted">O código do país (55) é adicionado automaticamente se você não informar.</small>
        </div>
      </form>
    </div>

    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <button type="submit" class="btn btn-success mr-1" :disabled="loading" @click="send()">
        <i class="bx bx-send mr-1"></i> Disparar teste
      </button>
    </template>
  </b-modal>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { required } from 'vuelidate/lib/validators'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import TemplatePreview from './TemplatePreview'
import { sendTest } from '../services'

export default {
  name: 'TemplateTestModal',
  components: { Loading, TemplatePreview },
  data () {
    return {
      modal: false,
      loading: false,
      submitted: false,
      template: null,
      phone: ''
    }
  },
  validations () {
    return {
      phone: { required }
    }
  },
  computed: {
    components () {
      return (this.template && this.template.components) || []
    },
    headerType () {
      if (this.template && this.template.dynamic_header_type === 'participant_qrcode') return 'QRCODE_PARTICIPANT'
      const c = this.components.find(x => x.type === 'HEADER')
      return c ? c.format : ''
    },
    headerText () {
      const c = this.components.find(x => x.type === 'HEADER')
      return c && c.format === 'TEXT' ? (c.text || '') : ''
    },
    headerImageUrl () {
      return (this.template && this.template.header_image_url) || ''
    },
    headerVideoUrl () {
      return (this.template && this.template.header_video_url) || ''
    },
    headerDocumentName () {
      const url = this.template && this.template.header_document_url
      if (!url) return ''
      return url.split('/').pop().split('?')[0]
    },
    bodyText () {
      const c = this.components.find(x => x.type === 'BODY')
      return c ? (c.text || '') : ''
    },
    footerText () {
      const c = this.components.find(x => x.type === 'FOOTER')
      return c ? (c.text || '') : ''
    },
    buttons () {
      const c = this.components.find(x => x.type === 'BUTTONS')
      return c ? (c.buttons || []) : []
    }
  },
  methods: {
    open (template) {
      this.template = template
      this.phone = ''
      this.submitted = false
      this.$v.$reset()
      this.modal = true
    },
    async send () {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.loading = true
      try {
        await sendTest(this.template.id, { phone: this.phone })
        successMessage('Mensagem de teste enviada com sucesso.', 2500)
        this.close()
      } catch (err) {
        const msg = err.response && err.response.data && err.response.data.error
          ? err.response.data.error
          : err.message
        errorMessage('Falha ao enviar teste: ' + msg)
      } finally {
        this.loading = false
      }
    },
    close () {
      this.modal = false
      this.template = null
      this.phone = ''
      this.submitted = false
      this.$v.$reset()
    }
  }
}
</script>

<style scoped>
.vld-overlay.is-full-page {
  z-index: 1051 !important;
}
</style>
